import React from 'react';
import Highlighter from 'react-highlight-words';
import { useSelector } from 'react-redux';

import { RootState } from '@/src/reducers/types';

interface HighlightSearchTermProps {
  customSearchTerm?: string;
  children: string;
}

const HighlightSearchTerm: React.FC<HighlightSearchTermProps> = ({
  customSearchTerm,
  children,
}) => {
  const searchTerm = useSelector((state: RootState) => state.filters.searchTerm);

  const keyWords = customSearchTerm ? customSearchTerm : searchTerm;

  return (
    <Highlighter
      searchWords={[keyWords]}
      textToHighlight={children || ''}
      highlightClassName="tw-p-0"
    />
  );
};

export default HighlightSearchTerm;
